import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quarter-rebate-message-box',
  templateUrl: './quarter-rebate-message-box.component.html',
  styleUrls: ['./quarter-rebate-message-box.component.scss'],
})
export class QuarterRebateMessageBoxComponent {
  @Input() showRebateButton = false;
  @Input() quarterRebateMessage: string;
}
